import { Button, Intent, Spinner } from '@blueprintjs/core';
import React, { Fragment, useEffect, useState } from 'react'
import ReactFullscreen from "react-full-screen";
import logo from '../../../../assets/logo.png';
import Session from '../../../../services/Session'
import * as _ from "lodash";
import ImageCardWithAttributesResume from 'components/Results/common/ImageCardWithAttributesResume';
import { translate } from 'utlis/translations/i18n';



const Results = ({ session, sequences, instance, protocol, onFinishResults }) => {

    let [loading, setLoading] = useState(true)
    let [sequencesData, setSequencesData] = useState([])
    let [maximum, setMaximum] = useState(0)
    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)


    useEffect(() => {
        let { results } = instance
        if (protocol !== 'MS' && protocol !== 'PC') {
            onFinishResults()
        }
        if (protocol === 'MC') {
            let img = new Image();
            img.src = session.data.mcCriterias[0].downloadURL
            img.onload = () => {
                let coef = 1
                if ((img.height > 800) && (img.height < 1000)) {
                    coef = 1.5
                } else if ((img.height > 1000) && (img.height < 1500)) {
                    coef = 2
                } else if ((img.height > 1500) && (img.height < 2000)) {
                    coef = 3
                }
                setHeight(img.height / coef)
                setWidth(img.width / coef)
            };

            for (const [key, value] of Object.entries(instance.results)) {
                let mySequence = sequences.find((sequence) => sequence.id === key)
                setSequencesData(sequencesData => [...sequencesData, { results: value[instance.id], sequence: mySequence }])
                setLoading(false)
            }
        } else if (protocol === 'PC') {
            let myResults = Session.exportPairComparaisonResults(session, results)
            let maximum = (myResults.length - 1) * 2 * myResults.length
            setSequencesData(myResults)
            setMaximum(maximum)
            setLoading(false)
        }

        // eslint-disable-next-line
    }, [])

    if (loading) return <Spinner className='margin-top-large' />

    if (protocol === 'MC') {
        return (
            <Fragment>
                <div className="context text-center margin-top-medium margin-bottom-small">
                    <div className='logo-container'>
                        <img src={logo} alt="logo" className='logo' />  &nbsp; &nbsp;
                                <span className='logo-title'>VisualSense</span>
                    </div>
                </div>
                {sequencesData < 1 ?
                    <h1>{translate('results.noResults')}</h1>
                    :
                    <div>
                        <div>
                            <div className=" multiple-channel-criteria-resume" id='personal-results'>
                                <div className="text-center" style={{ marginTop: "15px", marginBottom: "25px" }}>
                                    <h1>{session.metadata.name}</h1>
                                    <h3>{session.metadata.context}</h3>
                                </div>
                                <hr />
                                {sequencesData.map((sequ, i) => {
                                    let { results, sequence } = sequ
                                    let { resources } = sequence
                                    let attributes = session.metadata.attributes
                                    let totalAttibutes = []

                                    return (
                                        <Fragment key={i}>
                                            <h2 className='text-center'>{translate("SEQUENCE")} {i + 1}</h2>
                                            <div className="col-xs-12 result">
                                                <div className="row margin-bottom-large">
                                                    <div className="resource-wrapper">
                                                        <div className="resources" style={{ width: (width + "px"), height: (height + "px") }}>
                                                            {resources.map((channel, index) => (
                                                                <img
                                                                    key={index}
                                                                    className="img-responsive"
                                                                    alt="Resource (Multiple Channel)"
                                                                    src={channel.downloadURL}
                                                                    style={{ opacity: results[channel.id] / 100 }}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='margin-bottom-large'>
                                                    <div className="attributes-results">
                                                        {(attributes && attributes[0]) && resources.map((resource, index) => {
                                                            resource.attributes = session.data.mcCriterias.find(crit => crit.id === resource.id).attributes
                                                            return (
                                                                <div key={index} className="attributes-results-card">
                                                                    <h3>{resource.name}: {results[resource.id]}%</h3>
                                                                    {resource.attributes.map((attr, jndex) => {
                                                                        if (totalAttibutes[jndex]) {
                                                                            totalAttibutes[jndex] += Number(attr.quantity)
                                                                        } else {
                                                                            totalAttibutes.push(Number(attr.quantity))
                                                                        }
                                                                        return (
                                                                            <div key={`${index + jndex}`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                <div>
                                                                                    {attributes[jndex].name}:&nbsp;
                                                                            </div>
                                                                                <div>
                                                                                    {attr.quantity}&nbsp;
                                                                                {attributes[jndex].unit}
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    )
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                        )
                                                        }
                                                    </div>
                                                    <div className='margin-bottom-large'>
                                                        {(attributes && attributes[0]) &&
                                                            <ImageCardWithAttributesResume
                                                                index={i + 1}
                                                                attributes={attributes}
                                                                totalAttibutes={totalAttibutes}
                                                                ressourcesLength={resources.length}

                                                            />
                                                        }
                                                    </div>
                                                    <hr />
                                                </div>
                                            </div>
                                            {(i === sequencesData.length - 1) && (
                                                <div className='text-right margin-right-large margin-bottom-medium'>
                                                    <Button onClick={onFinishResults} intent={Intent.SUCCESS}
                                                    >{translate('next')}</Button>
                                                </div>
                                            )}
                                        </Fragment>
                                    )
                                })}
                            </div>
                        </div>
                        <br />
                    </div>
                }
            </Fragment>
        )
    } else if (protocol === 'PC') {
        return (
            <Fragment>
                <div className="context text-center margin-top-medium margin-bottom-small">
                    <div className='logo-container'>
                        <img src={logo} alt="logo" className='logo' />  &nbsp; &nbsp;
                                <span className='logo-title'>VisualSense</span>
                    </div>
                </div>
                <div className="text-center" style={{ marginTop: "15px" }}>
                    <h2>{session.metadata.name}</h2>
                    {session.metadata.context} <br />
                </div>
                {sequencesData < 1 ?
                    <h1>{translate('results.noResults')}</h1>
                    :
                    <div className="row">
                        {_.orderBy(sequencesData, ["points"], ["desc"]).map((result, index) => (
                            <PairComparaisonResourceResume
                                key={index}
                                rank={index + 1}
                                result={result}
                                maximum={maximum}
                            />
                        ))}
                    </div>
                }
                <br /><br />
                <div className='text-right margin-right-large'>
                    <Button onClick={onFinishResults} intent={Intent.SUCCESS}
                    >{translate('next')}</Button>
                </div>
            </Fragment>
        )
    } else {
        return null
    }
}

export default Results



class PairComparaisonResourceResume extends React.Component {
    state = {
        fullscreen: false
    }

    render() {
        const { result, rank, maximum } = this.props;
        const { resource, points } = result;
        let { fullscreen } = this.state

        return (
            <div className="col-xs-12 col-sm-6 col-lg-4">
                <div className="row pair-comparison-resume">
                    <div className="col-xs-12 col-md-7 col-lg-9 no-p-l-r resource">
                        <div className="ratio16-9 resource-wrapper">
                            <div className="resource">
                                {resource.type !== "VIDEO" && (
                                    <ReactFullscreen enabled={fullscreen}>
                                        <img
                                            className="img-responsive cursor-pointer"
                                            alt="Resource (Pair comparaison)"
                                            src={resource.downloadURL}
                                            onClick={() => this.setState({ fullscreen: !fullscreen })}
                                        />
                                    </ReactFullscreen>
                                )}
                                {resource.type === "VIDEO" && (
                                    <video
                                        className="img-responsive"
                                        alt="Resource (Pair comparaison)"
                                        src={resource.downloadURL}
                                        controls
                                        muted
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-5 col-lg-3 infos">
                        <div className="metadata">
                            <div className="label">{translate('results.rank')}</div>
                            <div className="value">{rank}</div>
                        </div>
                        <div className="metadata">
                            <div className="label">{translate('results.points')}</div>
                            <div className="value">{points}</div>
                        </div>
                        <div className="metadata">
                            <div className="label">{translate('results.rating')}</div>
                            <div className="value">{(points / maximum).toFixed(2)}</div>
                        </div>
                        <div className="metadata">
                            <div className="label">{translate('name')}</div>
                            <div className="value">{resource.name}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}